import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { SecurityGroupService } from "../services/securitygroup.service";
import { Observable } from "rxjs";
import { ISecurityGroup } from "../interfaces/isecuritygroup";

@Injectable()
export class SecurityGroupResolver implements Resolve<ISecurityGroup> {
    constructor(private securityGroupService: SecurityGroupService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<ISecurityGroup> {
        return this.securityGroupService.getSecurityGroup(route.params["id"]);
    }
}
